<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="350"
  >
    <template v-slot:activator="{ on, attrs }">
      <tooltip-btn
        v-if="!simpleButton"
        :color="color"
        :icon="icon"
        :tooltip="tooltip"
        text
        :title="title"
        v-bind="attrs"
        v-on="on"
      />
      <v-btn
        v-if="simpleButton"
        v-shortkey.once="['esc']"
        dark
        :color="color"
        min-width="90"
        tabindex="-1"
        v-bind="attrs"
        @shortkey="escape"
        v-on="on"
        v-html="$t(title)"
      />
    </template>
    <v-card>
      <v-card-title class="text-h5">
        {{ $t(question) }}
      </v-card-title>
      <v-card-text v-if="questionDescription">
        {{ $t(questionDescription) }}
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="green darken-1"
          text
          @click="escape"
        >
          {{ $t('disagree') }}
        </v-btn>
        <v-btn
          color="green darken-1"
          text
          @click="click"
        >
          {{ $t('agree') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

  import TooltipBtn from '@/components/TooltipBtn'

  export default {
    name: 'QuestionBtn',
    components: { TooltipBtn },
    props: {
      icon: {
        type: String,
        default: '',
      },
      tooltip: {
        type: String,
        default: '',
      },
      title: {
        type: String,
        default: '',
      },
      dynamic: {
        type: Boolean,
        default: false,
      },
      text: {
        type: Boolean,
        default: true,
      },
      question: {
        type: String,
        default: '',
      },
      questionDescription: {
        type: String,
        default: '',
      },
      show: {
        type: Boolean,
        default: true,
      },
      color: {
        type: String,
        default: '',
      },
      customClass: {
        type: String,
        default: 'px-0 ml-1',
      },
      simpleButton: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        dialog: false,
      }
    },
    computed: {
      dynamic_show () { return this.dynamic ? this.$vuetify.breakpoint.xs : true },
    },
    methods: {
      click () {
        this.dialog = false
        this.$emit('click')
        // console.log('click')
        // return this.$emit('click')
      },
      clickOK () {
        this.dialog = false
        this.click()
      },
      escape () {
        this.dialog = false
      },
    },
  }
</script>
